import { Box, CircularProgress, Modal } from "@mui/material";
import { useMutation, useQuery } from "@tanstack/react-query";
import { RxCross1 } from "react-icons/rx";
import { useEffect, useState } from "react";
import {
  cancelVaPaymentBilling,
  cancelVaPaymentBillingPbf,
} from "../../../services/billingAPI";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 600,
  bgcolor: "background.paper",
  boxShadow: 24,
  p: 4,
  borderRadius: 2,
};

const ModalCancelPaymentVa = ({
  open,
  setOpen,
  refetch,
  dataDetail,
  isPbf,
}) => {
  const [errorMessage, setErrorMessage] = useState("");

  const handleClose = () => {
    setErrorMessage("");
    setOpen(null);
  };

  const {
    refetch: cancelPayment,
    isFetching: isLoading,
    error,
    data,
  } = useQuery({
    queryKey: ["cancel-va"],
    queryFn: () => cancelVaPaymentBilling(dataDetail?.invoice_number),
    enabled: false,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    staleTime: 500,
  });

  const { mutate: mutateCancel, isLoading: isLoadingCancel } = useMutation({
    mutationFn: cancelVaPaymentBillingPbf,
    onSuccess: () => {
      setErrorMessage("");
      refetch();
      handleClose();
    },
    onError: (err) =>
      setErrorMessage(err.message.id ? err.message.id : err.message),
  });

  useEffect(() => {
    if (open) setErrorMessage("");
  }, [open]);

  useEffect(() => {
    setErrorMessage(
      error ? (error.message.id ? error.message.id : error.message) : "",
    );
  }, [error]);

  useEffect(() => {
    if (data && open) {
      setErrorMessage("");
      refetch();
      handleClose();
    }
  }, [data]);

  return (
    <Modal open={open} onClose={handleClose}>
      <Box
        sx={{
          ...style,
          maxWidth: "75%",
          overflowY: "auto",
          overflowX: "wrap",
          maxHeight: "50vh",
          padding: 0,
        }}
        className="text-left text-base w-3/4 lg:w-1/3"
      >
        <div className="flex justify-between items-center px-8 py-4 text-[12px]">
          <p className="font-bold text-lg ">Batalkan Pembayaran</p>
          <RxCross1
            className="cursor-pointer hover:text-red-500"
            onClick={handleClose}
          />
        </div>

        <div className="px-8 mb-4 text-[12px]">
          <p>
            Apakah anda yakin ingin membatalkan pembayaran untuk transaksi ini?
          </p>
          <p className="text-red-500 mt-2">
            {errorMessage && !isLoading && !isLoadingCancel ? errorMessage : ""}
          </p>
        </div>

        <div className="px-8 mb-4 flex gap-2 w-full">
          <button
            type="button"
            className="w-full rounded-md p-2 border-2 hover:bg-gray-100 disabled:bg-gray-300 text-[12px]"
            onClick={handleClose}
            disabled={isLoading || isLoadingCancel}
          >
            Cancel
          </button>
          <button
            type="button"
            className="w-full rounded-md p-2 bg-red-500 text-white hover:bg-gray-300 disabled:bg-gray-300 text-[12px]"
            onClick={() => {
              isPbf
                ? mutateCancel({ payment_uid: dataDetail?.payment.payment_uid })
                : cancelPayment();
            }}
            disabled={isLoading || isLoadingCancel}
          >
            {isLoading || isLoadingCancel ? (
              <CircularProgress size={10} />
            ) : (
              "Batalkan Pembayaran"
            )}
          </button>
        </div>
      </Box>
    </Modal>
  );
};

export default ModalCancelPaymentVa;
